import Vue from 'vue';
import VueRouter from 'vue-router';
import RouterView from '@/components/RouterView.vue';
import store from '@/store';
import * as V from '@/views';

Vue.use(VueRouter);

const shipmentChildren = [
  {
    path: 'details',
    name: 'business-scope.details',
    component: V.BusinessScopeDetails,
  },
  {
    path: 'events',
    name: 'business-scope.events',
    component: V.BusinessScopeEvents,
  },
  {
    path: 'contents',
    name: 'business-scope.contents',
    component: V.BusinessScopeContents,
  },
  {
    path: 'documents',
    name: 'business-scope.documents',
    component: V.BusinessScopeDocuments,
  },
  {
    path: 'iot',
    name: 'business-scope.iot',
    component: V.BusinessScopeIOT,
  },
];

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: { name: 'login' },
  },
  {
    path: '/login',
    name: 'login',
    component: V.Login,
  },
  {
    path: '/logout',
    name: 'logout',
    component: V.Logout,
  },
  {
    path: '/verify',
    name: 'verify',
    component: V.Verify,
  },
  {
    path: '/menu',
    name: 'menu',
    component: V.Home,
    meta: { auth: true },
    children: [
      {
        path: '/',
        name: 'menu.index',
        component: V.HomeMenu,
      },
      // {
      //   path: '/GDPR',
      //   name: 'GDPR.index',
      //   component: V.GDPR,
      // },
      {
        path: ':id',
        name: 'menu.child',
        component: V.HomeChild,
      },
      {
        path: ':id/url',
        name: 'menu.display',
        component: V.HomeFrame,
      },
    ],
  },
  {
    path: '/admin',
    component: RouterView,
    meta: { auth: true },
    children: [
      {
        path: '/',
        name: 'admin.index',
        component: V.BusinessScope,
      },
      {
        path: 'menu',
        name: 'menu.create',
        component: V.MenuCreate,
      },
      {
        path: 'groups',
        name: 'groups.create',
        component: V.GroupsCreate,
      },
      {
        path: 'permissions',
        name: 'permissions.create',
        component: V.PermissionCreate,
      },
      {
        path: 'setup/create',
        name: 'setup.create',
        component: V.SetupCreate,
      },
      {
        path: 'setup/:setup/edit',
        name: 'setup.edit',
        component: V.SetupCreate,
      },
      {
        path: 'users',
        name: 'admin.users',
        component: V.Users,
      },
      {
        path: 'users/bulkdelete',
        name: 'admin.users.bulkdelete',
        component: V.BulkDelete,
      },
      {
        path: 'logs',
        name: 'admin.logs.index',
        component: V.Logs,
        meta: { superadmin: true },
      },
    ],
  },
  {
    path: '/:scope/track_and_trace',
    name: 'business-scope.select_tt',
    component: V.BusinessScopeRedirect,
  },
  {
    path: '/:scope',
    name: 'business-scope.select',
    component: V.BusinessScopeRedirect,
  },
  {
    path: '/:scope/track_and_trace',
    name: 'business-scope.client',
    component: V.BusinessScopeClient,
    meta: { order: true },
    children: [
      {
        path: 'details',
        name: 'client.business-scope.redirect',
        component: V.BusinessScopeClientRedirect,
      },
      // {
      //   path: 'search',
      //   name: 'client.business-scope.search',
      //   component: V.BusinessScopeSearch,
      //   meta: { search: true },
      // },
      ...shipmentChildren.map(r => ({
        ...r,
        // path: r.path === 'details' ? 'shipment' : r.path,
        name: `client.${r.name}`,
      })),
    ],
  },
  {
    path: '/:scope/track_and_trace',
    name: 'business-scope.track-blank',
    component: V.BusinessScopeTrack,
    meta: { search: true },
    children: [
      {
        path: 'search',
        name: 'business-scope.search',
        component: V.BusinessScopeSearch,
      },
    ],
  },
  {
    path: '/:scope/track_and_trace/:number',
    name: 'business-scope.track',
    component: V.BusinessScopeTrack,
    meta: { order: true },
    children: shipmentChildren.map(r => (
      { ...r, name: `track.${r.name}` }
    )),
  },
  {
    path: '/:scope/docs',
    name: 'business-scope.docs',
    meta: { auth: true },
    component: V.Docs,
  },
  {
    path: '/thales/reports/:id',
    name: 'business-scope.reports',
    meta: { auth: true },
    component: V.Reports,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(r => r.meta.superadmin) && !store.state.IsSuperAdmin) {
    next({ name: 'admin.index' });
  } else if (to.name === 'login' && store.state.IsLogged) {
    next({ name: 'menu.index' });
  } else if (to.matched.some(r => r.meta.auth) && !store.state.IsLogged) {
    next({ name: 'login', query: from.query });
  } else {
    next();
  }
});

export default router;
